:global(.ant-typography).large-size {
  font-size: var(--rc-theme-font-size-text-lg);
}

:global(.ant-typography).medium-size {
  font-size: var(--rc-theme-font-size-text-base);
}

:global(.ant-typography).small-size {
  font-size: var(--rc-theme-font-size-text-sm);
}

:global(.ant-typography).base-weight {
  font-weight: var(--rc-theme-font-weight-base);
}

:global(.ant-typography).bold-weight {
  font-weight: var(--rc-theme-font-weight-bold);
}

:global(.ant-typography).medium-weight {
  font-weight: var(--rc-theme-font-weight-medium);
}

:global(.ant-typography).light-color {
  color: var(--rc-theme-color-surface-default);
}

:global(.ant-typography).title-color {
  color: var(--rc-theme-color-text-heading);
}

:global(.ant-typography).primary-color {
  color: var(--rc-theme-color-primary-default);
}

.typography--uppercase {
  text-transform: uppercase;
}

a:hover .typography--hover {
  color: var(--rc-theme-color-primary-default);
  text-decoration: underline;
}
